module.exports = __webpack_public_path__ + "static/media/verticalRectangle_pink.edd36bc8.svg";